import userHasCustomTourOperatorCode from './userHasCustomTourOperatorCode'
import userCustomTourOperatoreCode from './userCustomTourOperatoreCode'

/**
 * Method to supply the custom tour operator parameters needed
 * for the back-end. Currently holds the logic for when to
 * actually send the tour operator code with the request.
 *
 * @returns {Object} The object with all the parameters regarding
 * the custom tour operator code that is send along with some requests.
 */
export default () => ({
  tourOperatorCode: userHasCustomTourOperatorCode()
    ? userCustomTourOperatoreCode()
    : undefined,
})
